export default function clientConfig() {
  const config = {
    codCliente: 9170, //2170-aspprevefpc_cibrius_prd,
    //9170-aspprevefpc_cibrius_hmg
    plano: 2, // 2 = plano conabprev / 4 = plano família
    tipo: 2,
  }

  return config
}
